export default __webpack_public_path__ + "static/media/utility7.cac390d3.svg";